import { Button } from "primereact/button";
import { useState } from "react";
import { ICandidate } from "../Candidate/Candidate.model";
import { candidateExamService } from "../../service/CandidateExam/candidateExam.service";
import { Dialog } from "primereact/dialog";

function GenerateExamLink({
  candidate,
  loadCandidates,
}: {
  candidate: ICandidate;
  loadCandidates?: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [examLink, setExamLink] = useState("");
  const [dialogVisible, setDialogVisible] = useState(false);

  const generateLink = async () => {
    try {
      setLoading(true);

      const res = await candidateExamService.generateExamLink({
        candidate_id: candidate.id,
      });
      setExamLink(res.exam_link);
      loadCandidates?.();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const onHide = () => {
    setDialogVisible(false);
    setExamLink("");
  };

  const copyToClipboard = async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(examLink);
      } else {
        // Fallback for HTTP or unsupported browsers
        const textarea = document.createElement("textarea");
        textarea.value = examLink;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        textarea.remove();
      }
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const footerContent = (
    <div className="flex justify-end gap-2">
      {examLink ? (
        <Button label="Copy Link" icon="pi pi-copy" onClick={copyToClipboard} />
      ) : (
        <Button
          label="Generate"
          icon="pi pi-link"
          loading={loading}
          onClick={generateLink}
        />
      )}

      <Button
        label="Close"
        icon="pi pi-times"
        className="p-button-secondary"
        onClick={onHide}
      />
      <Button
        label="Generate new Exam Link"
        icon="pi pi-link"
        severity="info"
        onClick={() => {
          generateLink();
        }}
      />
    </div>
  );
  return (
    <>
      <Button
        label="Generate Exam Link"
        icon="pi pi-link"
        severity="info"
        onClick={() => {
          setDialogVisible(true);
          generateLink();
        }}
      />
      <Dialog
        header="Generate Exam Link"
        visible={dialogVisible}
        className="w-4"
        onHide={onHide}
        footer={footerContent}>
        <p>
          Candidate:
          <strong> {candidate?.name}</strong>
        </p>

        {examLink && (
          <div className="mt-3">
            <p>
              <strong>Generated Link:</strong>
            </p>
            <input
              type="text"
              value={examLink}
              readOnly
              className="p-inputtext w-full"
            />
          </div>
        )}
      </Dialog>
    </>
  );
}

export default GenerateExamLink;
